import { render, staticRenderFns } from "./FinalcialResources.vue?vue&type=template&id=96e4cc4e"
import script from "./FinalcialResources.vue?vue&type=script&lang=js"
export * from "./FinalcialResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports